import { get } from 'core_main/request';
import { updateStore, getStore } from 'core_main/store';
import { KNOWLEDGE_BASES_SELF_ENDPOINT } from './constants';
import {
  makeGetKnowledgeBaseDomainsEndpoint,
  makeInternalKnowledgeBaseDomainName,
} from './helpers';
import { GetKnowledgeBaseDomainsParameters } from './types';

export const fetchKnowledgeBase = () => {
  return get(KNOWLEDGE_BASES_SELF_ENDPOINT).then((res) => {
    const { id } = res.data;
    updateStore('knowledgeBaseId', id);
    return id;
  });
};
export const getOrFetchKnowledgeBaseId = () => {
  const store = getStore();
  const storedKnowledgeBaseId =
    store.settings.knowledgeBaseId || store.knowledgeBaseId;
  if (storedKnowledgeBaseId) {
    return Promise.resolve(storedKnowledgeBaseId);
  }
  return fetchKnowledgeBase();
};

export const fetchKnowledgeBaseDomain = (
  parameters: GetKnowledgeBaseDomainsParameters,
) => {
  return get(makeGetKnowledgeBaseDomainsEndpoint(parameters.knowledgeBaseId))
    .then((response) => {
      const externalDomainName = response?.data?.[0]?.attributes?.domainName;
      const domainName = externalDomainName
        ? `https://${externalDomainName}`
        : makeInternalKnowledgeBaseDomainName();
      updateStore('knowledgeBaseDomain', domainName);
      return domainName;
    })
    .catch((error) => {
      console.error('Error fetching Knowledge Base Domain', error);
      return undefined;
    });
};

export const getOrFetchKnowledgeBaseDomain = () => {
  const store = getStore();
  if (store.knowledgeBaseDomain) {
    return Promise.resolve(store.knowledgeBaseDomain);
  }
  return getOrFetchKnowledgeBaseId().then((knowledgeBaseId) =>
    fetchKnowledgeBaseDomain({ knowledgeBaseId }),
  );
};
